import { FaPlus } from 'react-icons/fa';
import AddAlpacaToEventForm from './AddAlpacaToEventForm';
import type { Event } from '../models/Event';
import { useSearchParams } from 'react-router';

export default function AddAlpacaToEvent({
  isOpen,
  event,
}: {
  isOpen: string;
  event: Event;
}) {
  const [, setSearchParams] = useSearchParams();

  return (
    <div id='accordion-open' data-accordion='open' className='my-1 mb-4'>
      <h2 id='accordion-open-heading-1' className='m-0'>
        <div>
          <button
            type='submit'
            name='isOpen'
            value={isOpen === 'false' ? 'true' : 'false'}
            onClick={() =>
              setSearchParams({ isOpen: isOpen === 'false' ? 'true' : 'false' })
            }
            className={`flex w-full items-center justify-between gap-3 border tracking-wide ${
              isOpen === 'true'
                ? 'rounded-b-none rounded-t-lg border-b-0'
                : 'rounded-lg'
            } g-gray-50  block w-full  rounded-lg border border-gray-300 p-2.5
              text-sm text-gray-900 focus:border-gray-400 focus:ring-gray-400
               dark:border-0 dark:bg-gray-700 dark:text-gray-400 dark:placeholder-gray-400 dark:focus:ring-gray-400`}
            data-accordion-target='#accordion-open-body-1'
            aria-expanded={isOpen === 'true'}
            aria-controls='accordion-open-body-1'
          >
            <span className='flex items-center gap-2'>
              <FaPlus /> Alpacas
            </span>
            <svg
              data-accordion-icon
              className='h-3 w-3 shrink-0 rotate-180'
              aria-hidden='true'
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 10 6'
            >
              <path
                stroke='currentColor'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M9 5 5 1 1 5'
              />
            </svg>
          </button>
        </div>
      </h2>
      <div
        id='accordion-open-body-1'
        className={`${isOpen === 'true' ? 'block' : 'hidden'}`}
        aria-labelledby='accordion-open-heading-1'
      >
        <div className='rounded-b-lg border border-gray-200 p-4 dark:border-gray-700 dark:bg-gray-900'>
          <div className=' px-1'>
            <AddAlpacaToEventForm event={event} />
          </div>
        </div>
      </div>
    </div>
  );
}
